import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  keywords: string;
  path: string;
  jsonLd?: Record<string, unknown>;
}

const CANONICAL_ORIGIN = 'https://cicccqh.cn';

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const useSeo = ({ title, description, keywords, path, jsonLd }: SeoOptions) => {
  useEffect(() => {
    const canonical = `${CANONICAL_ORIGIN}${path}`;

    document.title = title;
    document.documentElement.lang = 'zh-CN';

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('name', 'robots', 'index, follow');
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', '爆料看料');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', 'https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20flatlay%20with%20notebook%20magnifier%20and%20amber%20light%20on%20cream%20background%2C%20investigation%20mood%2C%20high%20detail&width=1200&height=630&seq=bl-og-cover&orientation=landscape');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', 'https://readdy.ai/api/search-image?query=warm%20editorial%20magazine%20flatlay%20with%20notebook%20magnifier%20and%20amber%20light%20on%20cream%20background%2C%20investigation%20mood%2C%20high%20detail&width=1200&height=630&seq=bl-tw-cover&orientation=landscape');
    upsertLink('canonical', canonical);

    let script: HTMLScriptElement | null = null;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [title, description, keywords, path, jsonLd]);
};